import { useSearch } from '@tanstack/react-router'
import { WithAuth } from '../../_hocs/with-auth'
import { FiltersBar } from '../_components/filters-bar'
import { InlineSearchbox } from '../_components/inline-searchbox'
import { PageLayout } from '../_components/ui/page-layout'
import { CompaniesTable } from './_components/companies-table'
import { CreateCompanyButton } from './_components/create-company-button'

const Companies = () => {
  const searchParams = useSearch({ strict: false }) as { search?: string }
  const search = searchParams?.search ?? ''

  return (
    <PageLayout
      title="Empresas"
      actions={<CreateCompanyButton />}
      filters={
        <FiltersBar>
          <InlineSearchbox search={search} placeholder="Busque por alguma instituição" />
        </FiltersBar>
      }
    >
      <CompaniesTable search={search || undefined} />
    </PageLayout>
  )
}

export default WithAuth(Companies, { allowedFor: ['staff'] })
